import styled from '@emotion/styled'

export const ExitButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  gap: 10px;
`
